import React from 'react';
import { formatStringAsCurrency } from '../../../Utils/stringUtils';
import ResultValue from '../../Simple/ResultValue';

export default function IPPSPayment(props) {

    return (<>
        <h4>IPPS Payment</h4>
        <ResultValue label="IPPS Comparable Rate" value={formatStringAsCurrency(props.result.ippsComparableRate)} />
        <ResultValue label="Outlier Payment - IPPS" value={formatStringAsCurrency(props.result.ippsOutlier)} />
    </>);
}